import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../../../services/utils.service';
import { Router } from '@angular/router';
import { UsersService } from '../../../services/users.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { OrganizationsService } from '../../../services/organizations.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent implements OnInit {
  organizations = [];
  // filteredOrganizations: Observable<any[]>;
  userForm: FormGroup;

  constructor(private fb: FormBuilder,
              private usersService: UsersService,
              private utilsService: UtilsService,
              private router: Router,
              private organizationsService: OrganizationsService) {
  }

  ngOnInit() {
    this.getOrganizations();
    this.userForm = this.fb.group({
      name: ['', Validators.required],
      phoneNumber: [''],
      organization: ['', Validators.required],
      password: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
    });
    this.userForm.get('organization').valueChanges
      .pipe(
        debounceTime(150),
        startWith(''),
        map(value => {
          return this.getOrganizations(value);
        }));
  }

  organizationDisplayFunction(organization) {
    if (organization) {
      return organization.name;
    }
  }

  createUser() {
    const user = this.userForm.value;
    this.usersService.createUser(user).subscribe((response) => {
      if (response.errors && response.errors.length > 0) {
        const errors = response.errors.map(err => err.message);
        this.utilsService.openSnackBar(errors, '');
      } else {
        this.utilsService.openSnackBar('User Created !!', '');
        this.router.navigate(['/users']);
      }
    }, (error) => {
      this.utilsService.openSnackBar('Unable to create user.', '');
      console.log('there was an error sending the query', error);
    });
  }

  private getOrganizations(value = '') {
    const filter: any = {
      paginationData: {},
      searchParam: value
    };
    filter.paginationData.pageSize = 10;
    filter.paginationData.pageIndex = 0;
    this.organizationsService.list(filter).subscribe(res => {
      this.organizations = res.data && res.data['organizations'].items;
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/users/new-user/new-user.component.ts